import { useEffect } from 'react';
import { UseFormSetValue, FieldValues, Path } from 'react-hook-form';

/**
 * Custom hook to populate form fields from saved data
 * @param savedData - The saved form data object from Redux store
 * @param setValue - The setValue function from react-hook-form
 * @param formType - Type parameter for type safety (optional, defaults to any)
 *
 * @example
 * const getSavedData = useAppSelector((state) => state.formData.payoutv2Data);
 * const { setValue } = useForm<AmountType>();
 * usePopulateFormFromSavedData(getSavedData, setValue);
 */
export const usePopulateFormFromSavedData = <T extends FieldValues>(
  savedData: T | null | undefined,
  setValue: UseFormSetValue<T>
) => {
  useEffect(() => {
    if (savedData) {
      Object.keys(savedData).forEach((key) => {
        setValue(
          key as Path<T>,
          savedData[key as keyof T],
          { shouldValidate: true, shouldDirty: true }
        );
      });
    }
  }, [savedData, setValue]);
};